import React from 'react';
import { Table, TableContainer } from '@mui/material';

import { CCTablePagination } from '../cc-table-pagination';
import { CCTableBody } from './cc-table-body';
import { CCTableHead } from './cc-table-head';
import { CCTableToolbar } from './cc-table-toolbar';

export const CCTableDesktop = () => {
  return (
    <>
      <CCTableToolbar />

      <TableContainer>
        <Table>
          <CCTableHead />
          <CCTableBody />
        </Table>
      </TableContainer>

      <CCTablePagination />
    </>
  );
};
